module.exports = __webpack_public_path__ + "img/sand-rock-big-09.c2acff05.png";